import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Client } from 'src/app/models';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ClientService {

  constructor(
    private http: HttpClient
  ) { }

  public add(data: Client | any): Observable<any> {
    return this.http.post(environment.host + '/clients', data);
  }

  public getAll(pagination: {
    page: number,
    limit: number
  }, searchName?: string): Observable<any> {
    return this.http.get(`${environment.host}/clients?page=${pagination.page}&limit=${pagination.limit}&text=${searchName || ''}`);
  }

  public edit(data: Client): Observable<any> {
    return this.http.put(environment.host + '/clients', data);
  }

  public delete(_id: string): Observable<any> {
    return this.http.delete(`${environment.host}/clients/${_id}`);
  }
}
